import { el, clear, crestSVG } from "./components";
import { login } from "../sync";

export function renderLogin(container: HTMLElement, onSuccess: () => void): void {
  clear(container);

  const crest = el("div", { class: "crest login-crest" });
  crest.appendChild(crestSVG());

  const title = el("h1", { class: "login-title", text: "Učimo hrvatski" });
  const sub = el("div", { class: "login-sub", text: "Anmeldung" });

  const input = el("input", {
    class: "login-input",
    attrs: {
      type: "password",
      placeholder: "Passwort",
      autocomplete: "current-password",
    },
  }) as HTMLInputElement;

  const error = el("div", { class: "login-error" });

  const button = el("button", {
    class: "btn btn-primary login-btn",
    text: "Anmelden",
  }) as HTMLButtonElement;

  const submit = async () => {
    if (button.disabled) return;
    error.textContent = "";
    button.disabled = true;
    button.textContent = "…";
    const r = await login(input.value);
    button.disabled = false;
    button.textContent = "Anmelden";
    if (r.ok) {
      onSuccess();
    } else {
      error.textContent = r.error || "Fehler";
      input.focus();
      input.select();
    }
  };

  button.addEventListener("click", submit);
  input.addEventListener("keydown", (e) => {
    if (e.key === "Enter") submit();
  });

  const card = el("div", { class: "card login-card" }, [crest, title, sub, input, error, button]);

  const wrap = el("div", { class: "login-wrap" }, [card]);

  container.appendChild(wrap);
  setTimeout(() => input.focus(), 50);
}
